
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { OfferMonetizationType, OfferMonetizationTypes } from '@/interfaces/titles';
import ToggleButton from '@/ui-components/ToggleButton.vue';

import { PlotRecommenderState } from './plot-recommender.store';

const LpPlotRecommender = namespace('LpPlotRecommender');

@Component({
	name: 'PlotRecommenderMonetizationTypeFilter',
	components: { ToggleButton },
})
export default class PlotRecommenderMonetizationTypeFilter extends Vue {
	@LpPlotRecommender.State filters: PlotRecommenderState['filters'];
	@LpPlotRecommender.Mutation SET_FILTER: Function;

	get options() {
		// not all monetization options shoudl be shown, there are some
		// that should not be selected
		const options = OfferMonetizationTypes.filter(f => f.visible) // show only visible types
			.sort((a, b) => a.priority - b.priority); // order by priority ASC
		return options;
	}

	isFilterActive(monetizationType: OfferMonetizationType) {
		return (this.filters.monetization_types || []).includes(monetizationType);
	}

	toggle(monetizationType: OfferMonetizationType) {
		const monetizationTypes = this.filters.monetization_types || [];

		const value = this.isFilterActive(monetizationType)
			? monetizationTypes.filter(item => item !== monetizationType)
			: monetizationTypes.concat(monetizationType);
		this.SET_FILTER({ key: 'monetization_types', value });
	}
}
